export const getInitialState = (): any => ({
  userModelsData: [],
  userModelsStatus: 0
});
